import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './TagSelector.scss'
import { ReactComponent as Close } from 'components/UI/icons/close-line.svg'
import { ReactComponent as Add } from 'components/UI/icons/add-line.svg'

function TagSelector({ options, selectedTags, onTagSelect, onTagRemove }) {
  return (
    <div className='tag-selector'>
      <div className='tag-selector__available'>
        {options.map((item) => (
          <div
            className='tag notActive'
            key={item.id}
            onClick={() => onTagSelect(item)}
          >
            {item.name}{' '}
            <span>
              <Add />
            </span>
          </div>
        ))}
      </div>

      <div className='tag-selector__selected'>
        {selectedTags.map((item) => (
          <div
            className='tag active'
            key={item.id}
            onClick={() => onTagRemove(item)}
          >
            {item.name}{' '}
            <span className='remove'>
              <Close />
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

TagSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedTags: PropTypes.arrayOf(PropTypes.object).isRequired,
  onTagSelect: PropTypes.func.isRequired,
  onTagRemove: PropTypes.func.isRequired,
}

function MultiSelectTag({ options, values, sortKey = 'id', onChange }) {
  const [selectedTags, setSelectedTags] = useState(values)

  const handleTagSelect = (tag) => {
    const newSelectedTags = [...selectedTags, tag]
    setSelectedTags(newSelectedTags)
    // отправляем выбранные теги
    onChange(newSelectedTags)
  }

  const handleTagRemove = (tag) => {
    const newSelectedTags = selectedTags.filter((t) => t.id !== tag.id)
    setSelectedTags(newSelectedTags)
    // отправляем обновленный список
    onChange(newSelectedTags)
  }

  const availableOptions = options
    .filter((opt) => !selectedTags.find((selected) => selected.id === opt.id))
    .sort((a, b) => (a[sortKey] > b[sortKey] ? 1 : -1))

  return (
    <TagSelector
      options={availableOptions}
      selectedTags={selectedTags}
      onTagSelect={handleTagSelect}
      onTagRemove={handleTagRemove}
    />
  )
}

MultiSelectTag.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  values: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default MultiSelectTag
